
import axios from '../config/axios';

export const url = '/api/formulariocontactanosegqvw'


export const customformulariovpyyj_676adc589ccea34376cf965e = ({
  correof58ql,
	mensajevc3b4,
	nombreeu35e,

}) => new Promise((resolve, reject) => {
  if (correof58ql && mensajevc3b4 && nombreeu35e) {
    axios.post(`${url}/custom/formulario`, {
      correof58ql,
			mensajevc3b4,
			nombreeu35e,

    },
    ).then((res) => {
      if (res.data.status === 'success') {
        resolve(res.data);
      } else {
        reject(res.data); 
      }
    }).catch((error) => {
      reject(error?.response?.data);
    });
  } else {
    reject({
      status: 'error',
      info: 'Verifique los parametros requeridos',
    });
  }
});



